import { useEffect, useState, useRef } from "react";
import { getGroups, getSitesWithCCTVIntegrations } from "../../Api Methods/Api";
import { useDispatch, useSelector } from "react-redux";
import classes from './CCTVIntegrations.module.css'
import CCTVIntegrationsList from "./CCTVIntegrationsList";
import DeviceLoadingGrid from "../../components/GridList/DeviceLoadingGrid";
import { Await, useLocation } from "react-router-dom";
import StatCard from "../../components/UI/Stats/StatCard";
import ActiveSitesSearchbar from "../ActiveSites/activeSitesSearchbar";
import CCTVIntegrationsSearchBar from "./CCTVIntegrationsSearchBar";
import { sub } from "date-fns";
import { serviceActions } from "../../store/service-Slice";
import mixpanel from "mixpanel-browser";
import { on } from "rsuite/esm/DOMHelper";
import CCTVAnalytics from "./CCTVAnalytics";
import { Button } from "primereact/button";
import { Tooltip } from "primereact/tooltip";
import { getLinkedOutputState } from "./linkedOutputState";

// Groups Camect rows by Site ID, keeping only sites with more than one Camect integration.
// `allSites` (unfiltered) determines which SiteIDs qualify; `filtered` is the currently
// filtered/searched set that the grouped rows are drawn from. When `requireMismatch` is set,
// sites are kept only if their Camect entries don't all share the same armed/disarmed state.
const getMultiCamectSites = (allSites, filtered, requireMismatch = false) => {
    const camectCountsBySiteID = {};
    allSites.forEach(item => {
        if (item.integrationType === 'CAMECT') {
            camectCountsBySiteID[item.key] = (camectCountsBySiteID[item.key] || 0) + 1;
        }
    });
    const multiCamectSiteIDs = new Set(
        Object.keys(camectCountsBySiteID).filter(siteID => camectCountsBySiteID[siteID] > 1)
    );

    const entriesBySiteID = {};
    filtered.forEach(item => {
        if (item.integrationType === 'CAMECT' && multiCamectSiteIDs.has(item.key)) {
            if (!entriesBySiteID[item.key]) entriesBySiteID[item.key] = [];
            entriesBySiteID[item.key].push(item);
        }
    });

    let groups = Object.values(entriesBySiteID);

    if (requireMismatch) {
        groups = groups.filter(entries => {
            const states = entries
                .map(entry => getLinkedOutputState(entry)?.isOn)
                .filter(isOn => isOn !== undefined && isOn !== null);
            return new Set(states).size > 1;
        });
    }

    return groups.map(entries => ({
        ...entries[0],
        camectEntries: entries
    }));
};

const CCTVIntegrations = () => {
    const location = useLocation();
    const navState = location.state ?? {};

    const dispatch = useDispatch();
    const client = useSelector(state => state.auth.client);
    const token = useSelector(state => state.auth.token);
    const role = useSelector(state => state.auth.role);
    const apiData = {
        token,
        client
    }
       


    const service = useSelector(state => state.service);
    const cachedSites = service.ThirdPartyCCTVTableData;
    const [sites, setSites]  = useState(cachedSites);
    const [loading, setLoading] = useState(() => {
      return !cachedSites || cachedSites.length === 0;
    });

    const [filteredData, setFilteredData] = useState([])
    const [pageSize, setPageSize] = useState(100)
    const [online, setOnline] = useState(navState.online ?? service.cctvOnline ?? 0)
    const [offline, setOffline] = useState(navState.offline ?? service.cctvOffline ?? 0)
    const [deviceTag, setDeviceTag] = useState(navState.deviceTag ?? service.cctvDeviceTag ?? null)
    const [groupName, setGroupName] = useState(navState.groupName ?? service.cctvGroupName ?? null)
    const [integrationType, setIntegraionType] = useState(navState.integrationType ?? service.cctvIntegrationType ?? null)
    const [connectionIssues, setConnectionIssues] = useState(navState.connectionIssues ?? service.cctvConnectionIssues ?? 0)
    const [armedState, setArmedState] = useState(navState.armedState ?? service.cctvArmedState ?? null)
    const [outputStatus, setOutputStatus] = useState(navState.outputStatus ?? service.cctvOutputStatus ?? null)
    const [multiCamectOnly, setMultiCamectOnly] = useState(navState.multiCamectOnly ?? service.cctvMultiCamectOnly ?? 0)
    const [multiCamectMismatchOnly, setMultiCamectMismatchOnly] = useState(navState.multiCamectMismatchOnly ?? service.cctvMultiCamectMismatchOnly ?? 0)
    const [siteActiveFilter, setSiteActiveFilter] = useState(navState.siteActiveFilter ?? service.cctvSiteActiveFilter ?? null)
    const [submit, setSubmit] = useState(0)
    const [showLoadMore, setShowLoadMore] = useState(true)

    const [totalCount, setTotalCount] = useState(null)
    const [ajaxCount, setAjaxCount] = useState(null)
    const [hikvisionCount, setHikvisionCount] = useState(null)
    const [dahuaCount, setDahuaCount] = useState(null)
    const [aiboxCount, setAiboxCount] = useState(null)

    const [totalUnstableCount, setTotalUnstableCount] = useState(null)
    const [unstableAjaxCount, setUnstableAjaxCount] = useState(null)
    const [unstableHikvisionCount, setUnstableHikvisionCount] = useState(null)
    const [unstableDahuaCount, setUnstableDahuaCount] = useState(null)
    const [unstableAiboxCount, setUnstableAiboxCount] = useState(null)

    const [totalOfflineCount, setTotalOfflineCount] = useState(null)
    const [offlineAjaxCount, setOfflineAjaxCount] = useState(null)
    const [offlineHikvisionCount, setOfflineHikvisionCount] = useState(null)
    const [offlineDahuaCount, setOfflineDahuaCount] = useState(null)
    const [offlineAiboxCount, setOfflineAiboxCount] = useState(null)

    const [searchTerm, setSearchTerm] = useState(navState.searchTerm ?? service.cctvSearchTerm ?? "")
    const [groups, setGroups] = useState([])
    const [activeTab, setActiveTab] = useState(0);
    const [missedPollsFilter, setMissedPollsFilter] = useState(navState.missedPollsFilter ?? service.cctvMissedPollsFilter ?? null);

    const prevBody = useRef();

    const listSitesWithCCTVIntegrations = async () => {
        setLoading(true);

        let body = {
            pageSize: 100000,
            pageOffset: 0,
            online: online,
            offline: offline,
            deviceTag: deviceTag,
            groupName: groupName,
            integrationType: integrationType,
            connectionIssues: connectionIssues
        }

        const response = await getSitesWithCCTVIntegrations(apiData, body, dispatch)

        setTotalCount(response.data[0][0].totalSites)
        setAjaxCount(response.data[0][0].ajaxCount)
        setHikvisionCount(response.data[0][0].hikvisionCount)
        setDahuaCount(response.data[0][0].dahuaCount)
        setAiboxCount(response.data[0][0].aiboxCount)

        setTotalUnstableCount((response.data[0][0].unstableAjaxCount ?? 0) + (response.data[0][0].unstableHikvisionCount ?? 0) + (response.data[0][0].unstableDahuaCount ?? 0) + (response.data[0][0].unstableAiboxCount ?? 0))
        setUnstableAjaxCount(response.data[0][0].unstableAjaxCount ?? 0)
        setUnstableHikvisionCount(response.data[0][0].unstableHikvisionCount ?? 0) 
        setUnstableDahuaCount(response.data[0][0].unstableDahuaCount ?? 0)
        setUnstableAiboxCount(response.data[0][0].unstableAiboxCount ?? 0)

        setTotalOfflineCount((response.data[0][0].offlineAjaxCount ?? 0) + (response.data[0][0].offlineHikvisionCount ?? 0) + (response.data[0][0].offlineDahuaCount ?? 0) + (response.data[0][0].offlineAiboxCount ?? 0))
        setOfflineAjaxCount(response.data[0][0].offlineAjaxCount ?? 0)
        setOfflineHikvisionCount(response.data[0][0].offlineHikvisionCount ?? 0)
        setOfflineDahuaCount(response.data[0][0].offlineDahuaCount ?? 0)
        setOfflineAiboxCount(response.data[0][0].offlineAiboxCount ?? 0)

        setSites(response.data[1])
        dispatch(serviceActions.set3rdPartyCCTVTableData(response.data[1]));

        if (response.data[1].length < body.pageSize) {
            // e.g. setHasMore(false)
            setShowLoadMore(false)
        }

        setLoading(false)

    }

    useEffect(() => {  
        GetGroups();

        mixpanel.track("3rd party CCTV tab visited", {
          user: localStorage.getItem('email')
        });
    }, [])

    useEffect(() => {
        listSitesWithCCTVIntegrations()
    }, [submit])

    const HandleLoadMore = async () => {
        setLoading(true)

        let body = {
            pageSize: 10000,
            pageOffset: sites.length,
            online: online,
            offline: offline,
            deviceTag: deviceTag,
            groupName: groupName,
            integrationType: integrationType,
            connectionIssues: connectionIssues
        }

        const response = await getSitesWithCCTVIntegrations(apiData, body, dispatch)

       
        setSites(response.data[1])

        if (response.data[1].length < body.pageSize) {
            // e.g. setHasMore(false)
            setShowLoadMore(false)
        }
        
        setLoading(false)
    }

    useEffect(() => {
        let filtered = sites.filter((item) =>
            Object.values(item).some((value) => value?.toString().toLowerCase().includes(searchTerm.toLowerCase()))
        );
        if (missedPollsFilter === 1) filtered = filtered.filter(item => item.stabilityPercentage != null && parseFloat(item.stabilityPercentage) >= 70 && parseFloat(item.stabilityPercentage) < 90);
        else if (missedPollsFilter === 2) filtered = filtered.filter(item => item.stabilityPercentage != null && parseFloat(item.stabilityPercentage) > 0 && parseFloat(item.stabilityPercentage) < 70);
        else if (missedPollsFilter === 3) filtered = filtered.filter(item => item.missed_polls >= 3);
        if (armedState === 1) filtered = filtered.filter(item => getLinkedOutputState(item)?.isOn === true);
        else if (armedState === 0) filtered = filtered.filter(item => getLinkedOutputState(item)?.isOn === false);
        if (outputStatus === 1) filtered = filtered.filter(item => getLinkedOutputState(item)?.isActive === true);
        else if (outputStatus === 0) filtered = filtered.filter(item => getLinkedOutputState(item)?.isActive === false);
        if (siteActiveFilter === 1) filtered = filtered.filter(item => item.active == 1 || item.active == "1");
        else if (siteActiveFilter === 0) filtered = filtered.filter(item => item.active == 0 || item.active == "0");
        if (multiCamectMismatchOnly === 1) filtered = getMultiCamectSites(sites, filtered, true);
        else if (multiCamectOnly === 1) filtered = getMultiCamectSites(sites, filtered, false);

        dispatch(serviceActions.updateCCTVFilters({
            cctvOnline: online,
            cctvOffline: offline,
            cctvDeviceTag: deviceTag,
            cctvGroupName: groupName,
            cctvIntegrationType: integrationType,
            cctvConnectionIssues: connectionIssues,
            cctvArmedState: armedState,
            cctvOutputStatus: outputStatus,
            cctvMultiCamectOnly: multiCamectOnly,
            cctvMultiCamectMismatchOnly: multiCamectMismatchOnly,
            cctvSiteActiveFilter: siteActiveFilter,
            cctvMissedPollsFilter: missedPollsFilter,
            cctvSearchTerm: searchTerm
        }));
        setFilteredData(filtered);

        let mixpanelBody = {
            online: online,
            offline: offline,
            deviceTag: deviceTag,
            groupName: groupName,
            integrationType: integrationType,
            armedState: armedState,
            outputStatus: outputStatus,
            multiCamectOnly: multiCamectOnly,
            multiCamectMismatchOnly: multiCamectMismatchOnly,
            siteActiveFilter: siteActiveFilter,
            "searchTerm": searchTerm
        }

        const timer = setTimeout(() => {
            if (prevBody.current && (JSON.stringify(mixpanelBody) !== JSON.stringify(prevBody.current))) {
                mixpanel.track("3rd party CCTV tab search performed", {
                    user: localStorage.getItem('email'),
                    body: mixpanelBody
                });
            }
            prevBody.current = mixpanelBody;
        }, 2000);
        return () => clearTimeout(timer);
    }, [sites, searchTerm, online, offline, deviceTag, groupName, integrationType, connectionIssues, missedPollsFilter, armedState, outputStatus, multiCamectOnly, multiCamectMismatchOnly, siteActiveFilter]);

    const GetGroups = async () => {
        try {
            const listOptions = await getGroups(apiData, dispatch);
            setGroups(listOptions || []);
        } catch (error) {
            console.error('Failed to fetch groups:', error);
            setGroups([]);
        }
    }

    return (
        <div style={{ width: "100%" }}>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(150px, 250px))", gap: "var(--gap-lg)", marginBottom: "8px", justifyContent: "start" }}>
            <StatCard title={"Total integrations"} value={totalCount} isLoading={loading} />
            <StatCard title={"AJAX"} value={ajaxCount} isLoading={loading} />
            <StatCard title={"Dahua"} value={dahuaCount} isLoading={loading} />
            <StatCard title={"Hikvision"} value={hikvisionCount} isLoading={loading} />
            <StatCard title={"AIBox"} value={aiboxCount} isLoading={loading} />
        </div>
         <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(150px, 250px))", gap: "var(--gap-lg)", marginBottom: "8px", justifyContent: "start" }}>
            <StatCard title={"Total offline integrations"} value={totalOfflineCount} isLoading={loading} />
            <StatCard title={"Offline AJAX"} value={offlineAjaxCount} isLoading={loading} tooltip={offlineAjaxCount > 0 ? "Number of AJAX devices considered offline as they have missed their last 3 polls, click to view these devices" : undefined} />
            <StatCard title={"Offline Dahua"} value={offlineDahuaCount} isLoading={loading} tooltip={offlineDahuaCount > 0 ? "Number of Dahua devices considered offline as they have missed their last 3 polls, click to view these devices" : undefined} />
            <StatCard title={"Offline Hikvision"} value={offlineHikvisionCount} isLoading={loading} tooltip={offlineHikvisionCount > 0 ? "Number of Hikvision devices considered offline as they have missed their last 3 polls, click to view these devices" : undefined} />
            <StatCard title={"Offline AIBox"} value={offlineAiboxCount} isLoading={loading} tooltip={offlineAiboxCount > 0 ? "Number of AIBox devices considered offline as they have missed their last 3 polls, click to view these devices" : undefined} />
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(150px, 250px))", gap: "var(--gap-lg)", marginBottom: "8px", justifyContent: "start" }}>
            <StatCard title={"Total unstable integrations"} value={totalUnstableCount} isLoading={loading} />
            <StatCard title={"Unstable AJAX"} value={unstableAjaxCount} isLoading={loading} />
            <StatCard title={"Unstable Dahua"} value={unstableDahuaCount} isLoading={loading} />
            <StatCard title={"Unstable Hikvision"} value={unstableHikvisionCount} isLoading={loading} />
            <StatCard title={"Unstable AIBox"} value={unstableAiboxCount} isLoading={loading} />
        </div>
<br/>
        <Await resolve={sites}>
          {(loadedSites) => {
            return (
              <>
                {activeTab == 0 && (
                  <>
                  <div className={classes.searchContainer}>
                              <CCTVIntegrationsSearchBar
                                  type="text"
                                  placeholder="Search..."
                                  value={searchTerm}
                                  onChange={(e) => setSearchTerm(e.target.value)}
                                  groups={groups}
                                  online={online}
                                  setOnline={setOnline}
                                  offline={offline}
                                  setOffline={setOffline}
                                  deviceTag={deviceTag}
                                  setDeviceTag={setDeviceTag}
                                  integrationType={integrationType}
                                  setIntegrationType={setIntegraionType}
                                  groupName={groupName}
                                  setGroupName={setGroupName}
                                  connectionIssues={connectionIssues}
                                  setConnectionIssues={setConnectionIssues}
                                  armedState={armedState}
                                  setArmedState={setArmedState}
                                  outputStatus={outputStatus}
                                  setOutputStatus={setOutputStatus}
                                  multiCamectOnly={multiCamectOnly}
                                  setMultiCamectOnly={setMultiCamectOnly}
                                  multiCamectMismatchOnly={multiCamectMismatchOnly}
                                  setMultiCamectMismatchOnly={setMultiCamectMismatchOnly}
                                  siteActiveFilter={siteActiveFilter}
                                  setSiteActiveFilter={setSiteActiveFilter}
                                  submit={submit}
                                  setSubmit={setSubmit}
                                  style={{
                                      padding: "10px", 
                                      width: "300px",    
                                      fontSize: "14px",  
                                      boxSizing: "border-box", 
                                      borderRadius: "4px",
                                  }}/>

                                  <br/>
                                    <p>Total results: {filteredData.length}</p>
                            </div>
<br/>
                             <div style={{ display: "flex", alignItems: "center", gap: "8px", flexWrap: "wrap" }}>
                                  <Button
                                      label="All sites"
                                      size="small"
                                      severity="secondary"
                                      outlined={missedPollsFilter !== null}
                                      onClick={() => setMissedPollsFilter(null)}
                                  />
                                  <Button
                                      label="Unstable (10%+ missed)"
                                      size="small"
                                      severity="warning"
                                      outlined={missedPollsFilter !== 1}
                                      onClick={() => setMissedPollsFilter(prev => prev === 1 ? null : 1)}
                                  />
                                  <i className="pi pi-info-circle cctv-filter-info-1" style={{ color: "#9ca3af", cursor: "default", fontSize: "14px" }} />
                                  <Tooltip target=".cctv-filter-info-1" style={{ maxWidth: "280px" }}>
                                      <span>These CCTV systems have missed more than 10% of their polls over the last 30 days. Such instability may result in scheduled arm and disarm to fail on occasion.</span>
                                  </Tooltip>

                                  <Button
                                      label="Very unstable (30%+ missed)"
                                      size="small"
                                      style={missedPollsFilter === 2
                                          ? { background: "#e67e22", borderColor: "#e67e22", color: "white" }
                                          : { borderColor: "#e67e22", color: "#e67e22", background: "transparent" }}
                                      onClick={() => setMissedPollsFilter(prev => prev === 2 ? null : 2)}
                                  />
                                  <i className="pi pi-info-circle cctv-filter-info-2" style={{ color: "#9ca3af", cursor: "default", fontSize: "14px" }} />
                                  <Tooltip target=".cctv-filter-info-2" style={{ maxWidth: "280px" }}>
                                      <span>These CCTV systems have missed more than 30% of their polls over the last 30 days. Such instability may result in scheduled arm and disarm to fail on occasion.</span>
                                  </Tooltip>

                                  <Button
                                      label="Offline"
                                      size="small"
                                      severity="danger"
                                      outlined={missedPollsFilter !== 3}
                                      onClick={() => setMissedPollsFilter(prev => prev === 3 ? null : 3)}
                                  />
                                  <i className="pi pi-info-circle cctv-filter-info-3" style={{ color: "#9ca3af", cursor: "default", fontSize: "14px" }} />
                                  <Tooltip target=".cctv-filter-info-3" style={{ maxWidth: "280px" }}>
                                      <span>These CCTV systems have missed 3 or more consecutive polls, indicating they are currently unreachable. Scheduled arm and disarm will likely fail.</span>
                                  </Tooltip>
                                
                              </div>

                            </>
                )}

                <br/>

                <div className={classes.tabsWrapper}>
                <div className={classes.tabs}>
                {["CCTV", ...(role === "admin" || role === "TechSupport" ? ["Connection Stability Analytics"] : [])].map((tab, i) => (
                  <button
                    key={tab}
                    className={`${classes.tab} ${activeTab === i ? classes.active : ""}`}
                    onClick={() => setActiveTab(i)}
                  >
                    {tab}
                  </button>
                ))}
              </div>

            {activeTab == 0 && ( 
              <>
                <div style={{ width: "100%"}}>
                            {loading ? (
                              <div style={{ display: "flex", width: "100%" }}>
                                <DeviceLoadingGrid
                                  CardCount={
                                    20
                                  }
                                />
                              </div>
                            ) : (
                              <>
                              <CCTVIntegrationsList
                                  sites={filteredData}
                                  setSites={setFilteredData}
                                  refreshSites={() => setSubmit(prev => prev + 1)}
                              />
                              </>
                              
                            )}
                          </div>

                          </>
                        )}

                        {activeTab == 1 && (
                          <>
                                <div className={classes.tabContent}>
                                    <CCTVAnalytics
                                        RTStats={{
                                            offlineAJAX:  offlineAjaxCount,
                                            offlineDahua: offlineDahuaCount,
                                            offlineHik:   offlineHikvisionCount,
                                            offlineAibox: offlineAiboxCount,
                                        }}
                                        onTileClick={(type) => {
                                            setIntegraionType(type);
                                            setMissedPollsFilter(3);
                                            setSubmit(prev => prev + 1);
                                            setActiveTab(0);
                                        }}
                                    />
                                </div>
                          </>
                        )}
                      </div>
            </>
            )
          }}
        </Await>
        </div>
      )
}

export default CCTVIntegrations;